import { render } from "./SubNavigationMobile.vue?vue&type=template&id=2c4c19d2"
import script from "./SubNavigationMobile.vue?vue&type=script&lang=js"
export * from "./SubNavigationMobile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__